<template>
  <div class="button-split-list">
    <ul>
      <slot></slot>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.button-split-list {
  padding: 10px 0;
  border-bottom: 1px solid #e5e5e5;
}

.button-split-list:last-child {
  border: 0;
}

ul {
  position: static;
  min-width: 160px;
  padding: 0;
  margin: 0;
  font-size: 14px;
  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)
  list-style: none;
  background-clip: padding-box;
  border: 0;
}

:deep(li),
:deep(label) {
  &:hover,
  &:focus {
    color: darken(#333, 5%);
    text-decoration: none;
    cursor: pointer;
    background-color: #f5f5f5;
  }
}

:deep(a) {
  padding: 10px 30px;
  display: block;
  clear: both;
  font-weight: 400;
  line-height: 14px;
  color: #333;
  white-space: nowrap; // prevent links from randomly breaking onto new lines
}

:deep(li) {
  &.header a {
    font-weight: 700;
    padding: 10px 20px;
  }

  :deep(&.header) {
    &:hover,
    &:focus {
      cursor: default;
      color: initial;
      background-color: initial;
    }

    a {
      font-weight: 700;
      padding: 10px 20px;
    }

    a:hover,
    a:focus {
      cursor: default;
    }
  }

  &.disabled > :deep(a) {
    color: #c4c7ca;
  }
}
</style>
